import * as React from 'react'
import { Form, Field, InjectedFormProps } from 'redux-form'
import { vRequired } from 'components/Input/Input.validations'
import { Input } from 'components/Input/Input'
import Button from 'components/Button'
import { dispatchToProps } from './ContactCreate.container'
import { IContactBase } from 'features/Contacts/types'
import cn from 'classnames'
import * as sMarg from 'styles/modules/margins.scss'
import { Row, Col } from 'components/Layout'
import * as sLay from 'styles/modules/layout.scss'

export interface IContactCreateProps extends InjectedFormProps<IContactBase> {
  push: typeof dispatchToProps['push']
  createContact: typeof dispatchToProps['createContact']
  onAfterSubmit: () => undefined
}

export class ContactCreateComponent extends React.Component<IContactCreateProps> {
  render() {
    const { submitting, handleSubmit, createContact, push, onAfterSubmit } = this.props
    const submit = (data: IContactBase) =>
      createContact(data).then(({ value: { data: contact } }) => {
        push(`/dashboard/contacts/${contact.id}`)
        onAfterSubmit()
      })

    return (
      <Form onSubmit={handleSubmit(submit as any)}>
        <Row className={cn(sLay['layout-row'], 'sm')}>
          <Col className={cn(sLay['flex-50'], 'sm')}>
            <Field name="firstName" label="First name" component={Input} />
          </Col>
          <Col className={cn(sLay['flex-50'], 'sm')}>
            <Field name="lastName" label="Last name" component={Input} />
          </Col>
        </Row>
        <Field name="company" label="Company" component={Input} />
        <Field
          name="phoneNumbers[0]"
          label="Phone Number"
          component={Input}
          validate={[vRequired]}
        />
        <div className={cn(sLay['layout-column'], sLay['layout-align-center-center'], sMarg.mt30)}>
          <Button color="tertiary" loading={submitting} type="submit">
            Create
          </Button>
        </div>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// src/features/Contacts/ContactCreate/ContactCreate.tsx